<template>
  <div class="faq">
    <!-- Faq Section -->
    <section id="faq" class="faq section light-background">
      <!-- Section Title -->
      <div class="container section-title" data-aos="fade-up">
        <h2>{{ title }}</h2>
      </div>
      <!-- End Section Title -->

      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-10" data-aos="fade-up" data-aos-delay="100">
            <div class="faq-container">
              <div
                v-for="(item, index) in dataFaq"
                :key="index"
                class="faq-item"
                :class="{ 'faq-active': activeIndex === index }"
                @click="toggleFaq(index)"
              >
                <h3>{{ item.question }}</h3>
                <div class="faq-content">
                  <p>{{ item.answer }}</p>
                </div>
                <i
                  class="faq-toggle bi"
                  :class="activeIndex === index ? 'bi-chevron-down' : 'bi-chevron-right'"
                ></i>
              </div>
            </div>
          </div>
          <!-- End Faq Column-->
        </div>
      </div>
    </section>
    <!-- /Faq Section -->
  </div>
</template>

<script>
import FaqJs from './js/app.js';
export default FaqJs;
</script>

<style scoped>
.faq .faq-item {
  cursor: pointer;
}
</style>
